import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const aloneOrWithSpouseState = atom({
  key: "aloneOrWithSpouseState",
  default: "",
  effects_UNSTABLE: [ocPersistAtom],
});
